import React from 'react';
import DialogComponent from '../DialogComponent/DialogComponent';

const BadgesCertificatesDialogBox = (props: any) => {
  const { openDialog, dialogContent, handleClose, skill } = props;
  const perPartBadgePercentage =  skill?.hasOwnProperty("perPartBadgePercentage") >= 0 ? skill?.perPartBadgePercentage : undefined;

  return (
    <DialogComponent
      openDialog={openDialog}
      title={""}
      handleClose={handleClose}
      perPartBadgePercentage={perPartBadgePercentage}
    >
      {dialogContent}
    </DialogComponent>
  );
};

export default BadgesCertificatesDialogBox;
